import { get, map } from 'lodash/fp';

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  corporations: [],
  departments: [],
  isLoading: false,
  isLoadingDepartments: false,
  isLoadingLocations: false,
  isLoadingCreate: false,
  locationsPage: 0,
  locationsCount: null,
  createdLocationId: null,
  isUpdatingSageId: false,
};
export const corporationListSlice = createSlice({
  name: 'corporationListSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */

    getCorporationsList: (state) => {
      state.isLoading = true;
    },
    getCorporationsListProcessed: (state, action) => {
      const { count, documents } = action.payload.data;
      const mappedCorporations = map((corp) => {
        const {
          _id,
          id,
          name,
          mailingAddress,
          metadata,
          quickBooksCompanyName,
          DNR,
          favorite,
          departments,
          sageId,
        } = corp;
        return {
          id: id || _id,
          name,
          mailingAddress: mailingAddress
            ? `${mailingAddress.address},${mailingAddress.city},${mailingAddress.state},${mailingAddress.zipcode}`
            : '',
          externalId: get(['bullhorn', 'id'], metadata),
          quickBooksCompanyName,
          DNR,
          favorite,
          departments,
          // place holder for map
          geoLoc: {
            longitude: Math.random() * 180,
            latitude: Math.random() * 85,
          },
          otherLocations: 'Other Location Placeholder, zip',
          sageId,
        };
      }, documents);
      state.totalRowCount = count;
      state.corporations = mappedCorporations;
      state.isLoading = false;
    },
    getCorporationsListError: (state) => {
      state.isLoading = false;
    },

    updateFavoriteDnr: (state) => {
      state.isPostingFavoriteDnr = true;
    },
    updateFavoriteDnrProcessed: (state) => {
      state.isPostingFavoriteDnr = false;
      // update current data in redux
      // const corporation = get(['payload', 'data', 'documents'], action);
      /* eslint-disable no-param-reassign */
    },
    updateFavoriteDnrError: (state) => {
      state.isPostingFavoriteDnr = false;
    },
    getDepartments: (state) => {
      state.isLoadingDepartments = true;
    },
    getDepartmentsProcessed: (state, action) => {
      const documents = get(['payload', 'data', 'documents'], action);
      state.isLoadingDepartments = false;
      state.departments = documents;
    },
    getDepartmentsError: (state) => {
      state.isLoadingDepartments = false;
    },

    getLocations: (state) => {
      state.isLoadinglocations = true;
    },
    clearLocations: (state) => {
      state.locations = [];
      state.locationsPage = 0;
    },
    getLocationsProcessed: (state, action) => {
      const documents = action?.payload?.data?.documents;
      state.isLoadingLocations = false;
      state.locations.push(...documents);
      state.locationsPage += 1;
      state.locationsCount = action?.payload?.data?.count;
    },
    getLocationsError: (state) => {
      state.isLoadingLocations = false;
    },
    createLocation: (state) => {
      state.isLoadingCreate = true;
    },
    createLocationProcessed: (state, action) => {
      state.isLoadingCreate = false;
      state.locationsCount += 1;
      state.createdLocationId = action.payload.data.id;
    },
    clearCreatedLocation: (state) => {
      state.createdLocationId = null;
    },
    createLocationError: (state) => {
      state.isLoadingCreate = false;
    },
    updateCorpSageId: (state) => {
      state.isUpdatingSageId = true;
    },
    updateCorpSageIdProcessed: (state, action) => {
      const { _id, sageId } = action.payload.data;
      state.isUpdatingSageId = false;
      state.corporations = state.corporations.map((corp) =>
        corp.id === _id ? { ...corp, sageId } : corp
      );
    },
    updateCorpSageIdError: (state) => {
      state.isUpdatingSageId = false;
    },

    createDepartment: (state) => {
      state.isLoading = true;
    },
    createDepartmentProcessed: (state) => {
      state.isLoading = false;
    },
    createDepartmentError: (state) => {
      state.isLoading = true;
    },

    editDepartment: (state) => {
      state.isLoading = true;
    },
    editDepartmentProcessed: (state) => {
      state.isLoading = false;
    },
    editDepartmentError: (state) => {
      state.isLoading = false;
    },

    deleteDepartment: (state) => {
      state.isLoading = true;
    },
    deleteDepartmentProcessed: (state) => {
      state.isLoading = false;
    },
    deleteDepartmentError: (state) => {
      state.isLoading = false;
    },
  },
});

export const corporationListReducer = corporationListSlice.reducer;

export const {
  getCorporationsList,
  getCorporationsListProcessed,
  getCorporationsListError,
  updateFavoriteDnr,
  updateFavoriteDnrProcessed,
  updateFavoriteDnrError,
  getDepartments,
  getDepartmentsProcessed,
  getDepartmentsError,
  clearLocations,
  getLocations,
  getLocationsError,
  getLocationsProcessed,
  setLatLng,
  createLocation,
  createLocationError,
  createLocationProcessed,
  updateCorpSageId,
  updateCorpSageIdProcessed,
  updateCorpSageIdError,
  clearCreatedLocation,
  createDepartment,
  createDepartmentProcessed,
  createDepartmentError,
  deleteDepartment,
  deleteDepartmentProcessed,
  deleteDepartmentError,
  editDepartment,
  editDepartmentProcessed,
  editDepartmentError,
} = corporationListSlice.actions;
